module.exports = __webpack_public_path__ + "static/mstile-310x310-0ae0a2524fc20cfff5abd14f9e7bb4d0.png";